import { render, staticRenderFns } from "./CopyRightEnglish.vue?vue&type=template&id=09195a45&scoped=true"
import script from "./CopyRightEnglish.vue?vue&type=script&lang=ts"
export * from "./CopyRightEnglish.vue?vue&type=script&lang=ts"
import style0 from "./CopyRightEnglish.vue?vue&type=style&index=0&id=09195a45&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09195a45",
  null
  
)

export default component.exports